import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../../assets/css/boletin.css";
import { supabase } from "../../services/supabaseClient";
import { ReactComponent as Facebook } from "../../assets/svg/brand-facebook.svg";
import { ReactComponent as WhatsApp } from "../../assets/svg/brand-whatsapp.svg";
import { ReactComponent as LinkIcon } from "../../assets/svg/link.svg";
export default function BoletinDetalle() {
  const { id } = useParams();
  const [noticia, setNoticia] = useState(null);
  const [recomendaciones, setRecomendaciones] = useState([]);
  const [error, setError] = useState(null);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Cargar noticia
    const fetchNoticia = async () => {
      const { data, error } = await supabase
        .from("articulos")
        .select("*")
        .eq("id", id)
        .single();
      if (error) setError(error);
      else setNoticia(data);
    };

    // Cargar recomendaciones
    const fetchRecomendaciones = async () => {
      const { data, error } = await supabase
        .from("articulos")
        .select("*")
        .eq("es_recomendacion", true)
        .order("fecha_publicacion", { ascending: false });
      if (!error) setRecomendaciones(data || []);
    };

    fetchNoticia();
    fetchRecomendaciones();
  }, [id]);

  function formatearFecha(fecha) {
    const opciones = { day: "numeric", month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    // Reemplaza "de 2025" por "del 2025"
    return `Fecha de publicación ${fechaFormateada.replace(
      / de (\d{4})$/,
      " del $1"
    )}`;
  }

  if (error) return <div>Error al cargar la noticia</div>;
  if (!noticia) {
    return (
      <div className="boletin-container">
        <div className="boletin-content">
          <div className="boletin-main">
            <div className="skeleton-noticia-destacada shimmer"></div>
          </div>
          <aside className="boletin-sidebar">
            <div className="skeleton-recomendacion shimmer"></div>
            <div className="skeleton-recomendacion shimmer"></div>
          </aside>
        </div>
      </div>
    );
  }

  const currentUrl = window.location.href;
  const imageUrl = noticia.portada;
  const title = noticia.titulo;
  // Limpiar HTML del contenido para la descripción
  const cleanDescription =
    noticia.contenido
      .replace(/<[^>]*>/g, "") // Quitar etiquetas HTML
      .replace(/\s+/g, " ") // Quitar espacios extra
      .trim()
      .substring(0, 155) + (noticia.contenido.length > 155 ? "..." : "");

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={cleanDescription} />

        {/* Open Graph Meta Tags para Facebook y otras redes sociales */}
        <meta property="og:url" content={currentUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={cleanDescription} />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:image:alt" content={title} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Torres & Torres Abogados" />
        <meta property="og:locale" content="es_ES" />

        {/* Artículo específico */}
        <meta
          property="article:published_time"
          content={noticia.fecha_publicacion}
        />
        <meta property="article:section" content="Boletín Legal" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={cleanDescription} />
        <meta name="twitter:image" content={imageUrl} />
        <meta name="twitter:image:alt" content={title} />

        {/* Meta adicionales para mejor SEO */}
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />
      </Helmet>

      <div className="boletin-container">
        <div className="boletin-content">
          <div className="boletin-main">
            <div className="noticia-detalle">
              <h1>{noticia.titulo}</h1>
              <div className="detalle-img-wrapper">
                {!imgLoaded && (
                  <div className="skeleton-noticia-detalle-img shimmer"></div>
                )}
                <img
                  src={noticia.portada}
                  alt={noticia.titulo}
                  className="detalle-img"
                  style={{ display: imgLoaded ? "block" : "none" }}
                  onLoad={() => setImgLoaded(true)}
                />
              </div>
              <div className="noticia-meta-share-row">
                <div className="noticia-meta">
                  {formatearFecha(noticia.fecha_publicacion)}
                </div>
                <div className="social-share-bar">
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      window.location.href
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Compartir en Facebook"
                  >
                    <Facebook />
                  </a>
                  <a
                    href={`https://wa.me/?text=${encodeURIComponent(
                      noticia.titulo + " " + window.location.href
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Compartir en WhatsApp"
                  >
                    <WhatsApp />
                  </a>
                  <button
                    className="copy-link-btn"
                    title="Copiar enlace"
                    onClick={() => {
                      navigator.clipboard.writeText(window.location.href);
                      setCopiado(true);
                      setTimeout(() => setCopiado(false), 3000);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                      marginLeft: "0px",
                      position: "relative",
                    }}
                  >
                    <LinkIcon />
                    {copiado && (
                      <span className="tooltip-copiado">Copiado</span>
                    )}
                  </button>
                </div>
              </div>
              <div className="divider"></div>
              <div
                className="noticia-contenido"
                dangerouslySetInnerHTML={{ __html: noticia.contenido }}
              ></div>
              {noticia.imagen_extra && (
                <img
                  src={noticia.imagen_extra}
                  alt="Extra"
                  className="detalle-img-extra"
                />
              )}
              {noticia.imagen_extra_2 && (
                <img
                  src={noticia.imagen_extra_2}
                  alt="Extra 2"
                  className="detalle-img-extra"
                />
              )}
            </div>
          </div>
          <aside className="boletin-sidebar">
            <h3 className="section-title">Recomendaciones</h3>
            <div className="recomendaciones-grid">
              {recomendaciones
                .filter((rec) => rec.id !== noticia.id) // Oculta la noticia actual
                .map((rec) => (
                  <Link
                    key={rec.id}
                    to={`/boletin/${rec.id}`}
                    className="recomendacion-card-link"
                    style={{ textDecoration: "none" }}
                  >
                    <div className="recomendacion-card">
                      <img
                        src={rec.portada}
                        alt={rec.titulo}
                        className="recomendacion-img"
                      />
                      <div className="recomendacion-info">
                        <h4 className="noticia-titulo-link">{rec.titulo}</h4>
                        <div className="noticia-meta">
                          {formatearFecha(rec.fecha_publicacion)}
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
}
